import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { agilityRiskVersion, storageKeys } from './agility-risk.constants';
import { AgilityRiskNavigationService } from './providers/agility-risk-navigation.service';
import { AgilityRiskThemeService } from './providers/agility-risk-theme.service';
import { LangChangeEvent } from '@ngx-translate/core/lib/translate.service';
import './agility-risk.extensions';
import { Message, MessageService } from 'primeng/api';
import { AgilityRiskMessageService } from './providers/agility-risk-message.service';

@Component({
  selector: 'lib-agility-risk',
  templateUrl: './agility-risk.component.html',
  styleUrls: ['./agility-risk.component.scss']
})
export class AgilityRiskComponent implements OnInit, OnDestroy {
  onLanguageChangedSubscription: Subscription;

  constructor(private translate: TranslateService,
              private localStorageService: LocalStorageService,
              private themeService: AgilityRiskThemeService,
              public navigationService: AgilityRiskNavigationService,
              private agilityMessageService: AgilityRiskMessageService,
              private messageService: MessageService) {
    console.log(`Agility Risk Module Version: ${agilityRiskVersion}`);

    if (localStorageService.get(storageKeys.preferredLanguage)) {
      translate.use(localStorageService.get(storageKeys.preferredLanguage));
    } else {
      translate.use((translate.getBrowserLang()));
    }
  }

  ngOnInit(): void {
    this.onLanguageChangedSubscription = this.translate.onLangChange.subscribe((evt: LangChangeEvent) => {
      this.translate.getTranslation(evt.lang);
    });
    this.agilityMessageService.status.subscribe((message: Message) => {
      this.messageService.add(message);
    });
  }

  ngOnDestroy(): void {
    this.onLanguageChangedSubscription.unsubscribe();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }
}
